module.exports = __webpack_public_path__ + "img/progress_032.3da7a551.png";